
import { api_host, api_auth} from '../../common/globals/constants';

export const getResponseGeneral = (currentObjectiveId,token,fecha_inicio,fecha_termino,schedule) => fetch(api_host+`/reporte/online/indicadores/getDetalleRendimientoGlobalObjetivoCustom/?objetivoId=${currentObjectiveId}&token=${token}&fechaInicio=${fecha_inicio}&fechaTermino=${fecha_termino}&horarioId=${schedule}&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2`)
.then(response => response.json())
